/**
 * Returns true if `value` is a non-empty string that is safe to use as a URL
 * in `<img src=>`, `<link href=>`, or CSS `url(...)`.
 *
 * Treats the literal strings `"undefined"` and `"null"` as falsy. These can
 * leak into the data layer when an upstream serializer or template literal
 * stringifies a missing value — e.g. `\`${maybeUndef}\`` evaluates to the
 * 9-char string `"undefined"`, which trivially passes a plain truthiness
 * check and gets rendered as `<img src="undefined">` or `background-image:
 * url(undefined)`. Both produce a request to `/undefined` and a console
 * 404. See ONENOW-457.
 */
export const isUsableUrl = (value: unknown): value is string => {
  if (typeof value !== "string") return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  return trimmed !== "undefined" && trimmed !== "null";
};

export default isUsableUrl;
